<template>
  <div class="client-container">
    <a-table
      :pagination="showPagination"
      :columns="tableColumns"
      :dataSource="tableDataList"
      :rowSelection="rowSelection"
      :scroll="{ x: 970, y: 450 }"
    >
    </a-table>

    <a-button
      @click.stop="closeWin"
      type="dashed"
      :style="{
        width: '200px',
        height: '40px',
        margin: '15px 10px 0px'
      }"
    >
      取 消
    </a-button>
    <a-button
      @click.stop="bindAuthRule"
      type="primary"
      :style="{
        width: '200px',
        height: '40px',
        margin: '15px 10px 0px'
      }"
    >
      绑 定
    </a-button>
  </div>
</template>
<script>
var num = 0;
var pageContext;
export default {
  name: "AuthRuleBind",
  props: {
    itemData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    layerid: {
      type: String,
      default: ""
    },
    lydata: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showPagination: false,
      pageSearchForm: this.$form.createForm(this),
      tableColumns: [
        {
          title: "菜单名称",
          dataIndex: "title",
          key: "title"
        },
        {
          title: "编号",
          dataIndex: "id",
          key: "id",
          width: "80px"
        },
        {
          title: "图标",
          dataIndex: "icon",
          key: "icon",
          width: "150px"
        },
        {
          title: "菜单URL/路由",
          dataIndex: "url",
          key: "url",
          width: "150px"
        }
      ],
      tableDataList: [],
      selectRowKeyList: [],
      rowSelection: {
        fixed: true,
        onChange: (selectedRowKeys, selectedRows) => {
          pageContext.selectRowKeyList = selectedRowKeys;
        },
        getCheckboxProps: record => {
          return {
            props: {
              defaultChecked: pageContext.selectRowKeyList.includes(
                "" + record.id
              )
            }
          };
        }
      }
    };
  },
  mounted() {
    pageContext = this;
    pageContext.selectRowKeyList = pageContext.itemData.rules;
    pageContext.refreshDataList();
  },
  methods: {
    async refreshDataList() {
      pageContext.$http
        .post("/AuthRule/getDataList", {
          platform_type: pageContext.itemData.platform_type,
        })
        .then(function(response) {
          if (response.data.status === 1) {
            pageContext.tableDataList = response.data.data.data_list;
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查");
          console.log(error);
        });
    },
    async bindAuthRule() {
      pageContext.$http
        .post("/AuthGroup/update", {
          id: pageContext.itemData.id,
          title: pageContext.itemData.title,
          sort: pageContext.itemData.sort,
          rules: pageContext.selectRowKeyList
        })
        .then(function(response) {
          if (response.data.status === 1) {
            pageContext.$parent.refreshDataList();
            pageContext.$message.success(response.data.msg);
            pageContext.$layer.close(pageContext.layerid);
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查");
          console.log(error);
        });
    },
    closeWin() {
      pageContext.$message.info("操作取消");
      pageContext.$layer.close(pageContext.layerid);
    }
  }
};
</script>
<style lang="scss" scoped>
.client-container {
  width: 100%;
  text-align: center;

  .ant-btn-circle {
    margin: 0px 5px;
  }
}
</style>
